import React from "react";
import OptimizedImage from "./OptimizedImage";

const About2 = () => {
  return (
    <div className="mt-10 bg-gray-50 rounded-md shadow-md p-4">
      {/* Intro and Mission Statement Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Intro Section */}
        <section className="px-6 py-8 text-center md:text-left">
          <h1 className="text-3xl font-bold text-gray-900 mb-4 text-shadow">Who We Are</h1>
          <p className="text-lg text-gray-700">
            At <span className="font-semibold text-green-700">UniwayStart</span>, we help businesses thrive in the digital age.
            <br />
            <span className="italic text-gray-500">AI is the new electricity — and we&#39;re here to power your future.</span>
          </p>
        </section>

        {/* Mission Statement */}
        <section className="px-6 py-8 text-gray-700 space-y-4 leading-relaxed font-sans">
          <h2 className="text-2xl font-semibold text-gray-900 mb-2 text-shadow">Our Mission</h2>
          <p>
            We specialize in AI-driven design and development, crafting solutions that align with your business goals.
          </p>
          <p>
            From responsive websites to custom applications, we build with purpose — combining innovation, strategy, and empathy.
          </p>
          <p>
            We believe in clarity, speed, and excellence. Every project is a partnership, and every solution is built to exceed expectations.
          </p>
          <p className="font-medium text-gray-800">
            Let’s build something extraordinary together.
          </p>
        </section>
      </div>

      {/* Visual Goal Section */}
      <section className="relative w-full h-[500px] mt-10 mb-10 overflow-hidden">
        <div className="absolute inset-0">
          <OptimizedImage
            src="/images/emp-1.jpg"
            alt="Team collaborating at UniwayStart"
            className="w-full h-full object-cover transform scale-110 transition-transform duration-500 hover:scale-125"
          />
        </div>
        <div className="absolute inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className=" rounded-lg p-8 max-w-3xl mx-auto text-center shadow-xl">
            <h2 className="text-3xl font-bold text-white mb-4 text-shadow">Our Vision</h2>
            <p className="text-gray-300 leading-relaxed text-shadow">
              To empower businesses through thoughtful design and cutting-edge development. We aim to deliver solutions that drive growth, foster innovation, and create lasting impact.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About2;